import {EarlyCutoffCd} from '../';
import {EnumHelper} from './enum-helper';

export class EarlyCutoffCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in EarlyCutoffCd ) {
      this._values.push(EarlyCutoffCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): EarlyCutoffCd {

    for ( const obj in EarlyCutoffCd ) {
      if (EarlyCutoffCd[obj] === value){
        return EarlyCutoffCd[obj] as EarlyCutoffCd;
      }
    }
  }
}

const EarlyCutoffCdHelper = new EarlyCutoffCdHelperEnumHelperClass();
export default EarlyCutoffCdHelper;
